import { fbt } from 'fbtee'
import type { EventType } from '../../types'

/** The Discover page's type filter; `all` mixes festivals and parties. */
export type BrowseType = EventType | 'all'
export const BROWSE_TYPES: readonly BrowseType[] = ['all', 'festival', 'party']

export function parseBrowseType(value: string | null): BrowseType {
  return value === 'festival' || value === 'party' ? value : 'all'
}

export function browseTypeLabel(type: BrowseType): string {
  switch (type) {
    case 'all': return fbt('All events', 'Discover page type filter: festivals and parties together')
    case 'festival': return fbt('Festivals', 'Discover page type filter: only festivals')
    case 'party': return fbt('Parties', 'Discover page type filter: only parties')
  }
}

/** Shorter label for the chip itself; the menu keeps `browseTypeLabel`. */
export function browseTypeChipLabel(type: BrowseType): string {
  return type === 'all' ? fbt('All', 'Compact Discover type chip: festivals and parties together') : browseTypeLabel(type)
}
